import axios from "axios";
import { API } from "../../constants";
import { toast } from "react-toastify";
export const messagesGet = async (findBy, token) => {
  try {
    const url = `${API?.API_V1}/messages${findBy}`;
    const res = await axios.get(url, null, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    console.error(await error.message);
    return { error: true };
  }
};
export const messageGet = async (id, token) => {
  try {
    const url = `${API?.API_V1}/message/${id}`;
    const res = await axios.get(url, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    console.error(await error.message);
    return { error: true };
  }
};
export const messagePost = async (body, token) => {
  try {
    const url = `${API?.API_V1}/message/create`;

    const res = await toast.promise(
      axios.post(
        url,
        { ...body },
        { headers: { Authorization: `Bearer ${token}` } }
      ),
      {
        pending: "ກຳລັງເພີ່ມທີ່ພັກ...",
        success: {
          render() {
            return "ເພີ່ມທີ່ພັກສຳເລັດ 👌";
          },
          autoClose: 1000,
        },
        error: {
          render() {
            return "Error ບໍ່ສາມາດເພີ່ມທີ່ພັກໄດ້ 🤯";
          },
          autoClose: 1000,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error(await error.message);
    return { error: true };
  }
};
export const messagePut = async (id, body, token) => {
  try {
    const url = `${API?.API_V1}/message/update`;
    const res = await toast.promise(
      axios.put(
        url,
        { id: id, data: body },
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      ),
      {
        pending: "ກຳລັງແກ້ໄຂທີ່ພັກ...",
        success: {
          render() {
            return "ແກ້ໄຂທີ່ພັກສຳເລັດ 👌";
          },
          autoClose: 1000,
        },
        error: "Error ບໍ່ສາມາດແກ້ໄຂທີ່ພັກໄດ້ 🤯",
      }
    );
    return res.data;
  } catch (error) {
    console.error(await error.message);
    return { error: true };
  }
};
export const messageDelete = async (id, token) => {
  try {
    const url = `${API?.API_V1}/message/delete`;
    const res = await toast.promise(
      axios.delete(url, {
        headers: {
          authorization: `Bearer ${token}`,
        },
        data: { id: id },
      }),
      {
        pending: "ກຳລັງລົບຊື່ຜູ້ໃຊ້...",
        success: {
          render() {
            return "ລົບຊື່ຜູ້ໃຊ້ສຳເລັດ 👌";
          },
          autoClose: 1000,
        },
        error: "Error ບໍ່ສາມາດລົບຊື່ຜູ້ໃຊ້ໄດ້ 🤯",
      }
    );
    return res.data;
  } catch (error) {
    console.error(await error.message);
    return { error: true };
  }
};
export const messageCountGet = async (findBy, token) => {
  try {
    const url = `${API?.API_V1}/message/count${findBy}`;
    const res = await axios.get(url, null, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    console.error(await error.message);
    return { error: true };
  }
};
export const mymessagePost = async (token) => {
  try {
    const url = `${API?.API_V1}/my-message`;
    const res = await axios.post(url, null, {
      headers: {
        authorization: `Bearer ${token}`,
      },
    });
    return res.data;
  } catch (error) {
    console.error(await error.message);
    return { error: true };
  }
};
